import axios from '@/framework/http/axios'
const model = 'user'
let authenticateByPhoneAndPasswordUrl = `api/${model}/authenticateByPhoneAndPassword`
let sendCaptchaByTypeUrl = `api/${model}/sendCaptchaByType`
let updateRealnameAndPasswordUrl = `api/${model}/updateRealnameAndPassword`
let authenticateByPhoneAndCaptchaUrl = `api/${model}/authenticateByPhoneAndCaptcha`
let updatePasswordByPhoneUrl = `api/${model}/updatePasswordByPhone`
let logoutUrl = `api/${model}/logout`
let findWithMeUrl = `api/${model}/findWithMe`
let updateInformationUrl = `api/${model}/updateInformation`
let validateByPhoneUrl = `api/${model}/validateByPhone`
let updatePasswordUrl = `api/${model}/updatePassword`
let updatePhoneUrl = `api/${model}/updatePhone`
let authenticateByStudentNumberUrl = `api/${model}/authenticateByStudentNumber`
let bindStudentNumberUrl = `api/${model}/bindStudentNumber`

//手机号和密码登陆
export function authenticateByPhoneAndPassword(param, callback) {
  axios.post(authenticateByPhoneAndPasswordUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      callback(data)
    }
  })
}
//发送验证码
export function sendCaptchaByType(param, callback) {
  axios.post(sendCaptchaByTypeUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      callback(data)
    }
  })
}
//首次设置个人信息
export function updateRealnameAndPassword(param, callback) {
  axios.post(updateRealnameAndPasswordUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      callback(data)
    }
  })
}
//手机号验证码登录
export function authenticateByPhoneAndCaptcha(param, callback) {
  axios.post(authenticateByPhoneAndCaptchaUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      callback(data)
    }
  })
}

//忘记密码
export function updatePasswordByPhone(param, callback) {
  axios.post(updatePasswordByPhoneUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      callback(data)
    }
  })
}
//退出
export function logout(param, callback) {
  axios.post(logoutUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      callback(data)
    }
  })
}
//获取个人信息
export function findWithMe(param, callback) {
  axios.post(findWithMeUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      callback(data)
    }
  })
}
//设置新密码
export function updatePassword(param, callback) {
  axios.post(updatePasswordUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}
//更新个人信息
export function updateInformation(param, callback) {
  axios.post(updateInformationUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}
//验证手机号和验证码
export function validateByPhone(param, callback) {
  axios.post(validateByPhoneUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}
//绑定新手机号
export function updatePhone(param, callback) {
  axios.post(updatePhoneUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}
export function authenticateByStudentNumber(param, callback) {
  axios.post(authenticateByStudentNumberUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}
export function bindStudentNumber(param, callback) {
  axios.post(bindStudentNumberUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}




// WEBPACK FOOTER //
// ./src/project/service/user.js